import React from "react";
import styled, { css } from "styled-components";
import Link from "../../Link";

const Item = styled.div`
  padding-right: 20px;
  padding-top: 4px;
  padding-bottom: 4px;
  cursor: pointer;
  user-select: none;
  display: flex;

  &:hover {
    background-color: #eee;
  }

  ${props =>
    props &&
    (props.level || props.level === 0) &&
    css`
      padding-left: ${25 + props.level * 30}px;
    `};
`;
const FolderTitle = styled(Item)``;

const ChartItem = styled(Item)`
  ${props =>
    props &&
    props.selected &&
    css`
      background-color: #60c2a9;
      background-image: linear-gradient(to right, #00aeee 0%, #a3d265 100%)!important
      color: white;
      font-weight: bold;
      border-radius: 5px 0px 0px 5px;
      -moz-border-radius: 5px 0px 0px 5px;
      -webkit-border-radius: 5px 0px 0px 5px;
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12) !important;
      div.stat {
        color: white;
      }
    `};
`;

const SubFolders = styled.div``;
// margin-left: 20px;

const Container = styled.div`
  padding-top: 0px;
  border-left: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;
  background-color: white;
  border-radius: 0px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12) !important;
  width: 100%;
`;

const GraphsContainer = styled.div`
  width: 100%;
`;

const Graph = styled.div``;

const GraphContainer = styled.div`
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12) !important;
  padding: 25px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin: 0px;
  background-color: white;
  border-radius: 5px;
  margin-bottom: 5px;
  border: 1px solid #eee;
`;

const NavigatorContainer = styled.div`
  max-width: 450px;
  min-width: 450px;
  margin-bottom: 20px;
`;

const Heading = styled.h3`
  font-size: 12pt;
  margin-top: 0px;
  padding-bottom: 12px;
  padding-top: 12px;
  margin-right: 0px;
  margin-left: 0px;
  padding-left: 14px;
  padding-right: 14px;
  text-transform: uppercase;
  margin-bottom: 0px;
`;

const PrimaryHeading = styled(Heading)``;
// background-color: #8e9aec;
// color: white;

const SearchHeading = styled(Heading)``;

const FolderList = styled(Container)``;

const Icon = styled.div`
  width: 25px;
  flex-shrink: 0;
`;

const Label = styled.div`
  flex-grow: 1;
`;
const Stat = styled.div.attrs({ className: "stat" })`
  width: 70px;
  margin-right: 20px;
  text-align: right;
  font-size: 8pt;
  color: #aaa;
  align-self: flex-start;
  padding-top: 3px;
  flex-shrink: 0;
`;

const Fail = styled.span`
  ${props =>
    props &&
    props.count > 0 &&
    css`
      color: red;
      font-weight: bold;
    `};
`;

const Warning = styled.span`
  ${props =>
    props &&
    props.count > 0 &&
    css`
      color: orange;
      font-weight: bold;
    `};
`;
const FadeIfEmpty = styled.div`
  ${props =>
    props.empty
      ? css`
          opacity: 0.5;
        `
      : css`
          opacity: 1;
        `};
`;

const HeaderLink = styled(Link).attrs({ className: "pull-right" })`
  text-decoration: underline;
  font-size: 10pt;
  padding-top: 3px;
`;

const Loading = styled(Container)`
  padding: 20px;
`;

const Body = styled.div`
  padding: 20px;
  padding-top: 0px;
`;

const RestrictedWidth = styled.div`
  max-width: 1400px;
  margin: 0 auto;
`;

export {
  FolderTitle,
  ChartItem,
  SubFolders,
  Container,
  FolderList,
  Icon,
  Label,
  Stat,
  Fail,
  Warning,
  PrimaryHeading,
  SearchHeading,
  FadeIfEmpty,
  HeaderLink,
  Loading,
  Body,
  NavigatorContainer,
  GraphContainer,
  GraphsContainer,
  Graph,
  RestrictedWidth
};
